module.exports = __webpack_public_path__ + "assets/a0c5def7e217cc756fcc22201bc51391.jpg";